/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Inventory_By_TitleInputs */

const en_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search inventory by title...`)
};

const es_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar inventario por título...`)
};

const fr_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechercher dans l'inventaire par titre...`)
};

const de_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inventar nach Titel durchsuchen...`)
};

const ja_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイトルでインベントリを検索...`)
};

const zh_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按标题搜索库存...`)
};

const ar_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ابحث في المخزون عن طريق العنوان...`)
};

const id_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cari inventaris berdasarkan judul...`)
};

const it_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cerca nell'inventario per titolo...`)
};

const ru_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поиск по инвентарю по названию...`)
};

const pt_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pesquisar inventário por título...`)
};

const ko_search_inventory_by_title = /** @type {(inputs: Search_Inventory_By_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`제목으로 인벤토리 검색...`)
};

/**
* | output |
* | --- |
* | "Search inventory by title..." |
*
* @param {Search_Inventory_By_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const search_inventory_by_title = /** @type {((inputs?: Search_Inventory_By_TitleInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Inventory_By_TitleInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_inventory_by_title(inputs)
	if (locale === "es") return es_search_inventory_by_title(inputs)
	if (locale === "fr") return fr_search_inventory_by_title(inputs)
	if (locale === "de") return de_search_inventory_by_title(inputs)
	if (locale === "ja") return ja_search_inventory_by_title(inputs)
	if (locale === "zh") return zh_search_inventory_by_title(inputs)
	if (locale === "ar") return ar_search_inventory_by_title(inputs)
	if (locale === "id") return id_search_inventory_by_title(inputs)
	if (locale === "it") return it_search_inventory_by_title(inputs)
	if (locale === "ru") return ru_search_inventory_by_title(inputs)
	if (locale === "pt") return pt_search_inventory_by_title(inputs)
	return ko_search_inventory_by_title(inputs)
});